<script setup>
import { computed, } from 'vue'
import Spinner from '../Spinner.vue';
import FormButton from '../../Atoms/FormButton.vue'
import Tooltip from '../../Atoms/Tooltip.vue'
import IconBase from '../../icon/IconBase.vue'
import IconInfoCircleOutline from '../../icon/IconInfoCircleOutline.vue'

const props = defineProps({
  stream: {
    type: Object,
    required: true,
    validator(v) {
      return Object.prototype.hasOwnProperty.call(v, '_id');
    }
  },
  streamAlive: {
    type: Boolean
  },
  isRtmpPullEnabled: {
    type: Boolean,
    default: false
  },
  rmptPullUrlProcessing: {
    type: Boolean,
    default: false
  },
  streamSourceType: {
    type: String
  },
  sourceTypes: {
    type: Object
  },
  disabled: {
    type: Boolean,
    default: false
  },
  streamSourceTypeProcessing: {
    type: Boolean
  }
})

const emit = defineEmits({
  'request-url': (url) => { return { url } },
  'set-stream-pull-url': () => true 
})

const tooltipMessage = computed(() => {
  return !props.isRtmpPullEnabled ? "This feature is not available for your plan. Please upgrade to use it." : "This can only be used when stream is live"
})

const requestUrl = (url) => emit('request-url', url);
const setStreamPullUrl = () => emit('set-stream-pull-url');

</script>
<template>
  <div class="mt-3">
    <FormButton size="sm" v-if="streamSourceType === sourceTypes?.Pull" class="w-full justify-center mb-2"
      :disabled="disabled || streamSourceTypeProcessing" @click="setStreamPullUrl">
      <Spinner v-if="streamSourceTypeProcessing" text="Retrieving data..." classes="text-dark-8"
        spinner-color="var(--c-surface-8)" spinner-size="12px" />
      <span v-else>Save</span>
    </FormButton>

    <div v-if="stream.type === 'restream'">
      <div class="flex items-center gap-1.5 mb-1.5">
        <span class="text-tiny font-medium text-surface-7">Pull this stream</span>
        <Tooltip content="Pull the live stream out of Castr as an RTMP or SRT source. Available while the stream is live.">
          <icon-base width="13" height="13" width-view-box="24" height-view-box="24" fill="none" class="text-surface-6">
            <icon-info-circle-outline />
          </icon-base>
        </Tooltip>
      </div>
      <div class="flex flex-wrap gap-2">
        <Tooltip :active="!streamAlive || !isRtmpPullEnabled">
          <FormButton type="secondary" size="sm" :disabled="!streamAlive || !isRtmpPullEnabled" @click="requestUrl('RTMP')">
            <Spinner v-if="rmptPullUrlProcessing" text="" classes="text-dark-8" spinner-color="var(--c-dark-8)"
              spinner-size="13px" />
            <span v-else>RTMP pull</span>
          </FormButton>
          <template #content>
            <span v-if="!streamAlive">{{ tooltipMessage }}</span>
            <span v-else class="text-surface-8 test-tiny">Click to get your RTMP pull URL. Need static URL? <a
                target="blank" class="text-reset text-underline"
                href="https://docs.castr.io/en/articles/4851668-how-to-get-constant-rtmp-address-in-castr">Here’s
                how</a>.</span>
          </template>
        </Tooltip>

        <Tooltip :active="!streamAlive || !isRtmpPullEnabled" :content="tooltipMessage">
          <FormButton type="secondary" size="sm" :disabled="!streamAlive || !isRtmpPullEnabled" @click="requestUrl('SRT')">
            <Spinner v-if="rmptPullUrlProcessing" text="" classes="text-surface-8" spinner-color="var(--c-dark-8)"
              spinner-size="13px" />
            <span v-else>SRT pull</span>
          </FormButton>
        </Tooltip>
      </div>
    </div>
  </div>
</template>